var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-page" },
    [
      _c(
        "tooltipLine",
        {
          attrs: {
            tip:
              _vm.$store.state.language === "en"
                ? require("@/assets/images/gd-en.png")
                : require("@/assets/images/gd.png"),
            visible: !(
              _vm.$store.state.user.hasBindData &&
              _vm.$store.state.user.hasBindData.isExistCs
            ),
            content: _vm.$t("work-order::auth_tooltip"),
          },
        },
        [
          _c("template", { slot: "btn" }, [
            _c(
              "span",
              { staticClass: "bind-btn", on: { click: _vm.onSetEmail } },
              [_vm._v(_vm._s(_vm.$t("user-guidance::guide::email_button")))]
            ),
          ]),
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { xl: 16, lg: 14, md: 12, sm: 10, xs: 24 },
            },
            [
              _c("label", { staticStyle: { width: "70px" } }, [
                _vm._v(_vm._s(_vm.$t("work-order::shopName"))),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("system::common::select_placeholder"),
                  },
                  on: { change: _vm.changeShop },
                  model: {
                    value: _vm.selectedShop,
                    callback: function ($$v) {
                      _vm.selectedShop = $$v
                    },
                    expression: "selectedShop",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c("el-option", {
                    key: item.shopId,
                    attrs: { label: item.shopName, value: item.shopId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { xl: 8, lg: 10, md: 12, sm: 14, xs: 24 },
            },
            [
              _c("label", { staticStyle: { width: "150px" } }, [
                _vm._v(_vm._s(_vm.$t("work-order::recieveDate"))),
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  clearable: false,
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": _vm.$t("system::time::text::include"),
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "picker-options": _vm.pickerOptions,
                },
                on: { change: _vm.handlerDateChange },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  on: {
                    click: function ($event) {
                      _vm.$router.push({
                        path: _vm.reportJumpUrl().workOrderAnalysis,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("system::common::btn::check_report")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "card-content", attrs: { gutter: 20 } },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item",
              attrs: { lg: 6, md: 6, sm: 12, xl: 6 },
            },
            [
              _c("dataCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.card,
                    expression: "loading.card",
                  },
                ],
                attrs: { option: item },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.acceptEmail,
                    expression: "loading.acceptEmail",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.acceptEmailConfig },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.emailType,
                    expression: "loading.emailType",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.emailTypeConfig },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.replier,
                      expression: "loading.replier",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.replierConfig },
                },
                [
                  _c(
                    "template",
                    { slot: "other" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: _vm.active === "people" ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeReplyType("people")
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("work-order::replier::table")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: _vm.active === "pointer" ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeReplyType("pointer")
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("work-order::station")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      prop: "responsePersonName",
                      label:
                        _vm.active === "people"
                          ? _vm.$t("work-order::replier::table_name")
                          : _vm.$t("work-order::station::table_name"),
                      "min-width": "125px",
                      showOverflowTooltip: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recieveEmails",
                      label: _vm.$t("work-order::replier::table_email"),
                      "min-width": "125px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unresponseNum",
                      label: _vm.$t("work-order::replier::table_notReply"),
                      "min-width": "125px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "responseNum",
                      label: _vm.$t("work-order::replier::table_reply"),
                      "min-width": "125px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "12HourResponseNum",
                      label: _vm.$t("work-order::replier::table_12reply"),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "1224HourResponseNum",
                      label: _vm.$t("work-order::replier::table_24reply"),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "2448HourResponseNum",
                      label: _vm.$t("work-order::replier::table_48reply"),
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "48OverHourResponseNum",
                      label: _vm.$t("work-order::replier::table_out48reply"),
                      "min-width": "180px",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("emailModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.onSave },
        model: {
          value: _vm.drawerVisable,
          callback: function ($$v) {
            _vm.drawerVisable = $$v
          },
          expression: "drawerVisable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }